import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTriggerIziviaMonprojetCases } from './hooks/useTriggerIziviaMonprojetCases';

export interface TriggerIziviaMonprojetCasesButtonProps {
  organizationId: string;
}

export function TriggerIziviaMonprojetCasesButton({
  organizationId,
}: TriggerIziviaMonprojetCasesButtonProps) {
  const { t } = useTranslation('organization');
  const { canTrigger, isPending, onTrigger } =
    useTriggerIziviaMonprojetCases(organizationId);

  if (!canTrigger) {
    return null;
  }

  return (
    <Tooltip title={t('detail.triggerIziviaMonprojetCasesHint')}>
      <Button
        size="small"
        loading={isPending}
        disabled={isPending}
        onClick={onTrigger}
      >
        {t('detail.triggerIziviaMonprojetCases')}
      </Button>
    </Tooltip>
  );
}
